import { Moment } from "config";

export class ActiveMonthStatus{
    static ACTIVE = 1;
    static INACTIVE = 2;
    static PRE_ACTIVE = 3;

    static data(type){
        switch(type){
            default: case ActiveMonthStatus.INACTIVE: return { label: 'Inativo', colorScheme: 'red', emoji: '🔴' }; break;
            case ActiveMonthStatus.ACTIVE: return { label: 'Ativo', colorScheme: 'green', emoji: '🟢' }; break;
            case ActiveMonthStatus.PRE_ACTIVE: return { label: 'Pré-Ativo', colorScheme: 'orange', emoji: '🟡' }; break;
        }
    }
}

export class OrderType{
    static CONSULTANT = 1;
    static DISTRIBUTOR = 2;
    static ADHESION = 3;
    static VOUCHER = 4;

    static data(type){
        switch(type){
            default: case OrderType.CONSULTANT: return { label: 'Consultor', colorScheme: 'gray', emoji: '🚚' }; break;
            case OrderType.DISTRIBUTOR: return { label: 'Núcleo', colorScheme: 'gray', emoji: '🚶‍♂️' }; break;
            case OrderType.ADHESION: return { label: 'Adesão', colorScheme: 'gray', emoji: '🚶‍♂️' }; break;
            case OrderType.VOUCHER: return { label: 'Adesão', colorScheme: 'gray', emoji: '🚶‍♂️' }; break;
        }
    }
}

export class OrderStatus{
    static DRAFT = 1
    static DONE = 2
    static APPROVED = 3
    static PROCESSING = 4
    static CANCELED = 5
    static MONTAGE = 6
    static QUOTATION = 7
    static WAITING_SHIPPING = 8
    static SHIPPING = 9
    static PARTIALLY_SHIPPING = 10
    static WITHDRAWAL = 11
    static ANALYZING = 12
    static FISCAL = 13

    static data(status){
        switch(status){
            default: case OrderStatus.DRAFT: return { label: 'Rascunho', colorScheme: 'gray', emoji: '🟡' }; break;
            case OrderStatus.DONE: return { label: 'Finalizado', colorScheme: 'gray', emoji: '🟢' }; break;
            case OrderStatus.APPROVED: return { label: 'Aprovado', colorScheme: 'teal', emoji: '🔴' }; break;
            case OrderStatus.PROCESSING: return { label: 'Processando', colorScheme: 'black', emoji: '🔴' }; break;
            case OrderStatus.CANCELED: return { label: 'Cancelado', colorScheme: 'red', emoji: '🔴' }; break;
            case OrderStatus.MONTAGE: return { label: 'Montagem', colorScheme: 'red', emoji: '🔴' }; break;
            case OrderStatus.QUOTATION: return { label: 'Cotação', colorScheme: 'red', emoji: '🔴' }; break;
            case OrderStatus.WAITING_SHIPPING: return { label: 'Pronto para envio', colorScheme: 'red', emoji: '🔴' }; break;
            case OrderStatus.SHIPPING: return { label: 'Em Trânsito', colorScheme: 'blue', emoji: '🚚' }; break;
            case OrderStatus.PARTIALLY_SHIPPING: return { label: 'Enviado parcialmente', colorScheme: 'red', emoji: '🔴' }; break;
            case OrderStatus.WITHDRAWAL: return { label: 'Aguardando retirada', colorScheme: 'orange', emoji: '🟠' }; break;
            case OrderStatus.ANALYZING: return { label: 'Análise', colorScheme: 'yellow', emoji: '🟡' }; break;
            case OrderStatus.FISCAL: return { label: 'Fiscal', colorScheme: 'yellow', emoji: '🟡' }; break;
        }
    }
}

export class OrderShippingType{
    static SHIPPING = 1;
    static WITHDRAW = 2;

    static data(type){
        switch(type){
            case OrderShippingType.SHIPPING: return { label: 'Para Entrega', colorScheme: 'gray', emoji: '🚚' }; break;
            default: case OrderShippingType.WITHDRAW: return { label: 'Retirada no núcleo', colorScheme: 'gray', emoji: '🚶‍♂️' }; break;
        }
    }
}

export class TransactionStatus{
    static DRAFT = 1;
    static APPROVED = 2;
    static ANALYZING = 3;
    static PAID = 4;
    static CANCELED = 5;
    static REFUNDED = 6;

    static data(status){
        switch(status){
            default: case TransactionStatus.DRAFT: return { label: 'Rascunho', colorScheme: 'gray', emoji: '' }; break;
            case TransactionStatus.APPROVED: return { label: 'Aprovado', colorScheme: 'teal', emoji: '' }; break;
            case TransactionStatus.ANALYZING: return { label: 'Em Análise', colorScheme: 'orange', emoji: '' }; break;
            case TransactionStatus.PAID: return { label: 'Pago', colorScheme: 'green', green: '' }; break;
            case TransactionStatus.CANCELED: return { label: 'Cancelado', colorScheme: 'red', emoji: '' }; break;
            case TransactionStatus.REFUNDED: return { label: 'Devolvido', colorScheme: 'purple', emoji: '' }; break;
        }
    }
}

export class BonusOperation{
    static ADD = 1;
    static REMOVE = 2;

    static data(operation){
        switch(operation){
            default: case BonusOperation.ADD: return { label: 'Adição', colorScheme: 'teal', emoji: '' }; break;
            case BonusOperation.REMOVE: return { label: 'Remoção', colorScheme: 'red', emoji: '' }; break;
        }
    }
}

export class WithdrawStatus{
    static DONE = 1;
    static ANALYZING = 2;
    static APPROVED = 3;
    static CANCELED = 4;
    static REJECTED = 5;

    static data(status){
        switch(status){
            default: case WithdrawStatus.DONE: return { label: 'Finalizado', colorScheme: 'teal', emoji: '' }; break;
            case WithdrawStatus.ANALYZING: return { label: 'Em Análise', colorScheme: 'orange', emoji: '' }; break;
            case WithdrawStatus.APPROVED: return { label: 'Aprovado', colorScheme: 'blue', emoji: '' }; break;
            case WithdrawStatus.CANCELED: return { label: 'Cancelado', colorScheme: 'red', emoji: '' }; break;
            case WithdrawStatus.REJECTED: return { label: 'Rejeitado', colorScheme: 'red', emoji: '' }; break;
        }
    }
}

export class BankAccountType{
    static CURRENT = 1;
    static SAVING = 2;

    static data(type){
        switch(type){
            default: case BankAccountType.CURRENT: return { label: 'Conta Corrente', colorScheme: 'teal', emoji: '' }; break;
            case BankAccountType.SAVING: return { label: 'Conta Poupança', colorScheme: 'teal', emoji: '' }; break;
        }
    }
}

export class BankAccountPixType{
    static MOBILE = 1;
    static EMAIL = 2;
    static CPF = 3;
    static CNPJ = 4;
    static RANDOM = 5;

    static data(type){
        switch(type){
            case BankAccountPixType.MOBILE: return { label: 'Celular', colorScheme: 'teal', emoji: '' }; break;
            case BankAccountPixType.EMAIL: return { label: 'E-mail', colorScheme: 'teal', emoji: '' }; break;
            case BankAccountPixType.CPF: return { label: 'CPF', colorScheme: 'teal', emoji: '' }; break;
            case BankAccountPixType.CNPJ: return { label: 'CNPJ', colorScheme: 'teal', emoji: '' }; break;
            default: case BankAccountPixType.RANDOM: return { label: 'Chave Aleatória', colorScheme: 'teal', emoji: '' }; break;
        }
    }
}

export class Roles{
    static ADMIN = "*";
    static MANAGE_CONSULTANTS = "manage_consultants";
    static MANAGE_DISTRIBUTORS = "manage_distributors";
    static MANAGE_EMPLOYEES = "manage_employees";
    static MANAGE_FINANCIAL = "manage_financial";
    static MANAGE_ORDERS = "manage_orders";
    static VIEW_REPORTS = "view_reports";

    static data(type){
        switch(type){
            case Roles.ADMIN: return { label: 'Administrador', description: 'Acesso total', colorScheme: 'teal', emoji: '' }; break;
            case Roles.MANAGE_CONSULTANTS: return { label: 'Gerenciar Consultores', description: 'Permissões de editar, criar e expirar consultores.', colorScheme: 'teal', emoji: '' }; break;
            case Roles.MANAGE_DISTRIBUTORS: return { label: 'Gerenciar Núcleos', description: 'Permissões de editar, criar e inativar núcleos.', colorScheme: 'teal', emoji: '' }; break;
            case Roles.MANAGE_EMPLOYEES: return { label: 'Ver e Gerenciar Funcionários', description: 'Permissões de editar, criar e remover funcionários.', colorScheme: 'teal', emoji: '' }; break;
            case Roles.MANAGE_FINANCIAL: return { label: 'Controle Financeiro', description: 'Gerencia débitos, créditos e saques.', colorScheme: 'teal', emoji: '' }; break;
            case Roles.MANAGE_ORDERS: return { label: 'Gerenciar Pedidos', description: 'Visualizar e alterar pedidos.', colorScheme: 'teal', emoji: '' }; break;
            case Roles.VIEW_REPORTS: return { label: 'Visualizar relatórios', description: 'Relatórios de clientes, núcleos e financeiro', colorScheme: 'teal', emoji: '' }; break;
            default: case Roles.RANDOM: return { label: 'N/D', description: '', colorScheme: 'teal', emoji: '' }; break;
        }
    }
}

export class Period{
    static LAST_7_DAYS = 'last_7_days';
    static LAST_14_DAYS = 'last_14_days';
    static LAST_30_DAYS = 'last_30_days';
    static LAST_3_MONTHS = 'last_3_months';
    static LAST_6_MONTHS = 'last_6_months';
    static LAST_1_YEAR = 'last_1_year';
    static TODAY = 'today';
    static YESTERDAY = 'yesterday';
    static WEEK = 'week';
    static LAST_WEEK = 'last_week';
    static MONTH = 'month';
    static LAST_MONTH = 'last_month';
    static YEAR = 'year';
    static ALL_PERIOD = 'all_period';

    static data(type){
        switch(type){
            case Period.LAST_7_DAYS: return { label: '7 dias' }; break;
            case Period.LAST_14_DAYS: return { label: '14 dias' }; break;
            case Period.LAST_30_DAYS: return { label: '30 dias' }; break;
            case Period.LAST_3_MONTHS: return { label: '3 meses' }; break;
            case Period.LAST_6_MONTHS: return { label: '6 meses' }; break;
            case Period.LAST_1_YEAR: return { label: 'Último ano' }; break;
            case Period.TODAY: return { label: 'Hoje' }; break;
            case Period.YESTERDAY: return { label: 'Ontem' }; break;
            case Period.WEEK: return { label: 'Esta semana' }; break;
            case Period.LAST_WEEK: return { label: 'Semana passada' }; break;
            case Period.MONTH: return { label: 'Este mês' }; break;
            case Period.LAST_MONTH: return { label: 'Mês passado' }; break;
            case Period.YEAR: return { label: Moment().format('Y') }; break;
            case Period.ALL_PERIOD: return { label: 'Todo o período' }; break;
            default: return { label: 'N/D' }; break;
        }
    }
}

export class InvoiceStatus{
    static ARRIVING           = 'arriving';
    static PARTIALLY_RECEIVED = 'partially_received';
    static FULLY_RECEIVED     = 'fully_received';
    static REJECTED           = 'rejected';
    static CANCELED           = 'canceled';
    static PROVISIONAL        = 'provisional';

    static data(value){
        switch(value){
            case InvoiceStatus.ARRIVING:           return { label: 'Aguardando Carga',        colorScheme: 'yellow'  }; break;
            case InvoiceStatus.PARTIALLY_RECEIVED: return { label: 'Parcialmente Recebido',   colorScheme: 'orange'  }; break;
            case InvoiceStatus.FULLY_RECEIVED:     return { label: 'Totalmente Recebido',     colorScheme: 'green'   }; break;
            case InvoiceStatus.REJECTED:           return { label: 'Rejeitada',               colorScheme: 'red'     }; break;
            case InvoiceStatus.CANCELED:           return { label: 'Cancelada',               colorScheme: 'gray'    }; break;
            case InvoiceStatus.PROVISIONAL:        return { label: 'Provisória',              colorScheme: 'purple'  }; break;
            default:                               return { label: value ?? 'Desconhecido',   colorScheme: 'gray'    }; break;
        }
    }
}

export class StockMovementType{
    static IN_PURCHASE       = 'in_purchase';
    static RELEASE_BLOCKED   = 'release_blocked';
    static TRANSFER_OUT      = 'transfer_out';
    static TRANSFER_IN       = 'transfer_in';
    static LOSS              = 'loss';
    static MANUAL_ADJUSTMENT = 'manual_adjustment';

    static data(value){
        switch(value){
            case StockMovementType.IN_PURCHASE:       return { label: 'Entrada por NF-e',      colorScheme: 'green'  }; break;
            case StockMovementType.RELEASE_BLOCKED:   return { label: 'Liberação de Bloqueio', colorScheme: 'teal'   }; break;
            case StockMovementType.TRANSFER_OUT:      return { label: 'Saída - Transferência', colorScheme: 'orange' }; break;
            case StockMovementType.TRANSFER_IN:       return { label: 'Entrada - Transferência', colorScheme: 'blue' }; break;
            case StockMovementType.LOSS:              return { label: 'Perda Registrada',      colorScheme: 'red'    }; break;
            case StockMovementType.MANUAL_ADJUSTMENT: return { label: 'Ajuste Manual',         colorScheme: 'purple' }; break;
            default:                                  return { label: value ?? 'Desconhecido', colorScheme: 'gray'   }; break;
        }
    }
}

export class FiscalNoteStatus{
    static DRAFT = 1;
    static GENERATED = 2;
    static PROCESSING = 3;
    static WAITING = 4;
    static CANCELED = 5;

    static data(type){
        switch(type){
            case FiscalNoteStatus.GENERATED: return { label: 'Emitida', colorScheme: 'teal', emoji: '🟢' }; break;
            case FiscalNoteStatus.PROCESSING: return { label: 'Processando', colorScheme: 'black', emoji: '🟡' }; break;
            case FiscalNoteStatus.WAITING: return { label: 'Aguardando Confirmação', colorScheme: 'orange', emoji: '🟡' }; break;
            case FiscalNoteStatus.CANCELED: return { label: 'Cancelada', colorScheme: 'red', emoji: '🔴' }; break;

            default: case FiscalNoteStatus.DRAFT: return { label: 'Rascunho', colorScheme: 'gray', emoji: '' }; break;
        }
    }
}